import React from 'react'
import CheckIcon from '@mui/icons-material/Check';
import { getInitials } from '../../utilities/helpers';

function ShiftPoolBidCard(props) {
  const weekHours = props.info?.employee_pickup_hours ? props.info?.employee_pickup_hours : 0

  console.log("BID", props.info)

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const month = monthNames[date.getMonth()];
    const day = date.getDate();

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';

    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12

    const minutesStr = minutes < 10 ? '0' + minutes : minutes;

    return `${month} ${day}, ${hours}:${minutesStr}${ampm}`;
  }

  return (
    <div
      onClick={props.handleBidSelect}
      className={`w-full bg-white border rounded-xl p-4 cursor-pointer transition-all ${
        props.isSelected
          ? "border-emerald-500 bg-emerald-50 shadow-sm"
          : "border-slate-200 hover:border-slate-300"
      }`}
    >
      <div className="flex items-start">
        {/* Avatar */}
        <div
          className={`w-12 h-12 rounded-full flex items-center justify-center ${
            props.isSelected ? "bg-emerald-100" : "bg-violet-100"
          }`}
        >
          <span
            className={`font-semibold text-base ${
              props.isSelected ? "text-emerald-700" : "text-violet-700"
            }`}
          >
            {getInitials(
              props.info.employee_pickup.first_name,
              props.info.employee_pickup.last_name
            )}
          </span>
        </div>

        {/* Content */}
        <div className="ml-3 flex-1">
          {/* Name */}
          <p className="text-base font-medium text-slate-900 mb-1">
            {props.info.employee_pickup.first_name}{" "}
            {props.info.employee_pickup.last_name}
          </p>

          {/* Submitted Date */}
          <p className="text-xs text-slate-500 mb-3">
            Submitted {formatTimestamp(props.info?.created_at)}
          </p>

          {/* Hours Info */}
          <div className="flex space-x-6">
            <div className="flex-1">
              <p className="text-xs font-medium text-slate-500 uppercase">
                Current Hours
              </p>
              <p className="text-sm font-semibold text-slate-900 mt-1">
                {weekHours} hrs
              </p>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-slate-500 uppercase">
                After Pickup
              </p>
              <p className="text-sm font-semibold text-violet-600 mt-1">
                {weekHours + props.hours} hrs
              </p>
            </div>
          </div>
        </div>

        {/* Selection Indicator */}
        <div className="ml-4 flex items-center self-stretch">
          {props.isSelected ? (
            <div className="w-6 h-6 rounded-full bg-emerald-500 flex items-center justify-center shadow-sm">
              <CheckIcon sx={{ color: 'white', fontSize: 14 }} />
            </div>
          ) : (
            <div className="w-6 h-6 rounded-full border-2 border-slate-300 bg-white"></div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ShiftPoolBidCard
